import axios from "axios";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import MinimalSelect from "../../components/MinimalSelect";
import Modal from "../../components/Modal";
import theme from "../../styles/theme";
import { PillarType } from "../../types/Roadmap";
import { useEffect, useState } from "react";
import { Icon, Icon as MuiIcon } from "@mui/material";
import { components } from "react-select";
import styled from "styled-components";
import Button from "../../components/Button";

interface EditDerivedProps {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  derivedProgram?: string;
  currentCompetencyId: string;
  handleSave: (
    currentCompetencyId: string,
    newSourceCompetencyId: string,
    newSourceVersionId: number
  ) => void;
}
export const EditDerived = (props: EditDerivedProps) => {
  const Title = styled.div`
    gap: 10px;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  `;

  const { isOpen, setOpen, derivedProgram, currentCompetencyId, handleSave } =
    props;
  type PillarCustomType = {
    label: string;
    value: string;
    selected: boolean;
    index: string;
    graphics: any;
    subdomains: Array<any>;
  };
  const [pillars, setPillars] = useState<Array<PillarCustomType>>([]);
  const [activeDerivedVersion, setActiveDerivedVersion] = useState<number>(0);
  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [selectedCompetency, setSelectedCompetency] = useState<{
    label: string;
    value: string;
  } | null>(null);

  const [currentPillarVersion, setCurrentPillarVersion] = useState<number>(0);
  const [selectedPillar, setSelectedPillar] = useState(null);

  const fetchPillars = (version: number) => {
    // axios
    //   .get(`/version?university_code=CMKL&program_name=${derivedProgram}`)
    //   .then((res) => {
    //     const active_version =
    //       res?.data?.versions.find((v: any) => v.status === "Active Prime")
    //         ?.version_number || 0;
    //     setActiveDerivedVersion(active_version);
    //     if (active_version) {
    //       axios
    //         .get(`/subdomain?curriculum_version=${active_version}`)
    //         .then((res) => {
    //           mapPillars(res.data.pillars);
    //         })
    //         .catch(() => {});
    //     }
    //   });
    setSelectedCompetency(null);
    setSelectedPillar(null);
    setCompetencies([]);
    setPillars([]);
    axios
      .get(`/subdomain?curriculum_version=${version}`)
      .then((res) => {
        mapPillars(res.data.pillars);
      })
      .catch(() => {});
  };

  const getCompetenciesByPillar = (pillarId?: string) => {
    setSelectedCompetency(null);
    if (!pillarId) return;
    axios
      .get(
        `competency/summary?university_code=CMKL&curriculum_version=${currentPillarVersion}&pillar_id=${pillarId}`
      )
      .then((res) => {
        const options = (res.data.competencies || []).map((v: any) => ({
          label: "[ " + v.competency_code + " ] " + v.title,
          value: v.id,
        }));
        setCompetencies(options);
      })
      .catch(() => {});
  };

  const [currUniversity, setCurrentUniversity] = useState<any>(
    localStorage.getItem("university")
  );
  const [versions, setVersions] = useState<
    Array<{ value: number; label: string }>
  >([]);

  const getAllVersion = () => {
    axios
      .get(
        `/version?university_code=${currUniversity}&program_name=${derivedProgram}`
      )
      .then((res) => {
        const transformedArray = res.data.versions
          ?.filter(
            (v: any) =>
              v.status === "Active Prime" || v.status === "Active Legacy"
          )
          .map((item: any) => ({
            value: item.version_number,
            label: item.title + " : " + item.display_version,
          }));
        console.log("transformedArray", transformedArray);
        setVersions(transformedArray);
      })
      .catch(() => {});
  };

  // const handleSave = () => {
  //   if (!selectedCompetency) return;
  //   axios
  //     .post("/competency/reset-derived-from", {
  //       competency_template_id: currentCompetencyId,
  //       new_source_competency_template_id: selectedCompetency.value,
  //       new_source_version_id: activeDerivedVersion,
  //     })
  //     .then(() => {
  //       setOpen(false);
  //     })
  //     .catch(() => {});
  // };

  const mapPillars = (data: PillarType) => {
    const custom: Array<{
      label: string;
      value: string;
      selected: boolean;
      index: string;
      graphics: any;
      subdomains: Array<any>;
    }> = [];
    data.forEach((element: any) => {
      custom.push({
        value: element.id,
        label: element.title,
        selected: false,
        index: "",
        graphics: element.graphics,
        subdomains: element.subdomains,
      });
    });
    setPillars(custom);
  };

  const { Option, SingleValue } = components;
  const CustomSingleValue = (props: any) => {
    if (!props.data) return null;
    return (
      <SingleValue {...props}>
        <MuiIcon
          sx={{
            mr: 1,
            padding: "4px",
            background: props.data.graphics.iconbg,
            boxShadow: props.data.graphics.iconshadow,
            borderRadius: "100px",
            fontSize: "14px",
            verticalAlign: "sub",
            color: "white",
          }}
        >
          {props.data.graphics.icon}
        </MuiIcon>
        <span className="react-select__single-value">
          {props.selectProps.getOptionLabel(props.data)}
        </span>
      </SingleValue>
    );
  };

  const IconOption = (props: any) => (
    <Option {...props}>
      <MuiIcon
        sx={{
          mr: 1,
          padding: "4px",
          background: props.data.graphics.iconbg,
          boxShadow: props.data.graphics.iconshadow,
          borderRadius: "100px",
          verticalAlign: "bottom",
          fontSize: "14px",
          color: "white",
        }}
      >
        {props.data.graphics.icon}
      </MuiIcon>
      {props.data.label}
    </Option>
  );

  useEffect(() => {
    // fetchPillars();
    getAllVersion();
  }, []);

  return (
    <Modal
      isOpen={isOpen || false}
      setOpen={setOpen}
      customStyle={{
        overlay: { zIndex: "999999" },
        content: {
          maxWidth: "500px",
          // minHeight: 600,
          padding: "0 16px 24px 16px",
          position: "relative",
        },
      }}
    >
      <FlexBox
        style={{
          height: "64px",
          borderBottom: "1px solid rgb(219, 219, 219)",
        }}
      >
        <Title
          style={{
            fontWeight: "normal",
            fontSize: 20,
            color: "rgb(71, 85, 105)",
          }}
        >
          <Icon>move_up</Icon>
          Edit Derived From
        </Title>
      </FlexBox>
      <div style={{ marginTop: 20 }}>
        <Title style={{ color: "#64748b" }}>Select Version</Title>
        <MinimalSelect
          // menuPortalTarget={document.body}

          placeholder="Choose version..."
          styles={{
            container: (base) => ({
              ...base,
              padding: "10px 0",
              width: "100%",
              maxWidth: "100%",
              marginBottom: 20,
            }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
              color: theme.color.lightBlueGray800,
            }),
          }}
          options={versions}
          onChange={(e: any) => {
            fetchPillars(e?.value);
            setCurrentPillarVersion(e?.value);
          }}
        />
      </div>
      {pillars?.length!==0 && <div>
        <Title style={{ color: "#64748b" }}>Select Pillar</Title>
        <MinimalSelect
          // menuPortalTarget={document.body}
          value={selectedPillar}
          placeholder="Choose pillar..."
          styles={{
            container: (base) => ({
              ...base,
              padding: "10px 0",
              width: "100%",
              maxWidth: "100%",
              marginBottom: 20,
            }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
              color: theme.color.lightBlueGray800,
            }),
          }}
          options={pillars}
          components={{
            Option: IconOption,
            // ValueContainer: ValueContainerLabel,
            SingleValue: CustomSingleValue,
          }}
          onChange={(e: any) => {
            getCompetenciesByPillar(e?.value);
            setSelectedPillar(e);
          }}
        />
      </div>}
      {competencies?.length !== 0 && (
        <div style={{ marginBottom: 10 }}>
          <Title style={{ color: "#64748b" }}>Select Competency</Title>
          <MinimalSelect
            // menuPortalTarget={document.body}

            placeholder="Choose competency..."
            styles={{
              container: (base) => ({
                ...base,
                padding: "10px 0",
                width: "100%",
                maxWidth: "100%",
                marginBottom: 20,
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
                color: theme.color.lightBlueGray800,
              }),
            }}
            options={competencies}
            value={selectedCompetency}
            onChange={(e: any) => setSelectedCompetency(e || null)}
          />
        </div>
      )}
      <FlexBox justify="end">
        <FlexGrow style={{ flexGrow: "0" }}>
          <Button
            style={{
              width: "151px",
              height: "48px",
              padding: "13px 12px",
              color: "rgb(100, 116, 139)",
              // backgroundColor: "#0061ff",
              // boxShadow: "0 0 5px gray",
              border: "2px solid rgb(100, 116, 139)",
            }}
            type="button"
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>
        </FlexGrow>
        <FlexGrow style={{ flexGrow: "0" }}>
          <Button
            style={{
              width: "151px",
              height: "48px",
              padding: "13px 12px",
              color: "white",
              backgroundColor: "#0061ff",
              boxShadow: "0 0 5px gray",
              border: "none",
            }}
            type="button"
            onClick={() => {
              if (!selectedCompetency) return;
              handleSave(
                selectedCompetency.value,
                currentCompetencyId,
                currentPillarVersion
              );
            }}
            disabled={!selectedCompetency}
          >
            Save
          </Button>
        </FlexGrow>
      </FlexBox>
    </Modal>
  );
};
